import Phaser from 'Phaser';
import LobbyScene from '../Lobby/LobbyScene';
import * as utility from '../../modules/utility';

import textureAtlas from '../../assets/textureAtlas.png';
import textureAtlasJson from '../../assets/textureAtlas.json';

// Images
import lockIcon from '../../assets/individualImages/lock.png';
import honeyIcon from '../../assets/individualImages/honeyIcon.png';
import honeyOutlineIcon from '../../assets/individualImages/honeyOutlineIcon.png';
import workerIcon from '../../assets/individualImages/workerIcon.png';
import matchesIcon from '../../assets/individualImages/matchesIcon.png';
import workerImage from '../../assets/individualImages/worker.png';
import bumbleBeeWorkerImage from '../../assets/individualImages/bumbleBeeWorker.png';
import catBeeImage from '../../assets/individualImages/honeyBeeWorkerSkinCat.png';
import blueBeeImage from '../../assets/individualImages/honeyBeeWorkerSkinBlue.png';
import violetBeeImage from '../../assets/individualImages/honeyBeeWorkerSkinViolet.png';
import crownBeeImage from '../../assets/individualImages/queenBeeCrownSkin.png';
import sweatBeeImage from '../../assets/individualImages/sweatBee.png';
import fedoraBeeImage from '../../assets/individualImages/melliferaFedora.png';
import partyHatBeeImage from '../../assets/individualImages/melliferaPartyHat.png';
import hornsBeeImage from '../../assets/individualImages/melliferaHorns.png';
import gasMaskBeeImage from '../../assets/individualImages/melliferaGasMask.png';
import threeCorneredHatBeeImage from '../../assets/individualImages/melliferaThreeCorneredHat.png';
import splashScreenIcon from '../../assets/marketing/splashScreenIcon.png';
import mainMenuTitle from '../../assets/individualImages/mainMenuTitle.png';

// Gifs
import howToPlayMove from '../../assets/video/howToPlayMove.gif';
import howToPlayNewHive from '../../assets/video/howToPlayNewHive.gif';
import howToPlayLayEgg from '../../assets/video/howToPlayLayEgg.gif';
import howToPlaySelectWorker from '../../assets/video/howToPlaySelectWorker.gif';
import howToPlayAttack from '../../assets/video/howToPlayAttack.gif';
import howToPlayEatHoney from '../../assets/video/howToPlayEatHoney.gif';

import worker from '../../assets/animations/worker.png';
import workerJson from '../../assets/animations/worker.json';
import workerAtlas from '../../assets/animations/worker.txt';

import wasp from '../../assets/animations/wasp.png';
import waspJson from '../../assets/animations/wasp.json';
import waspAtlas from '../../assets/animations/wasp.txt';

import foxglove from '../../assets/animations/foxglove.png';
import foxgloveJson from '../../assets/animations/foxglove.json';
import foxgloveAtlas from '../../assets/animations/foxglove.txt';

import echinacea from '../../assets/animations/echinacea.png';
import echinaceaJson from '../../assets/animations/echinacea.json';
import echinaceaAtlas from '../../assets/animations/echinacea.txt';

import strawberry from '../../assets/animations/strawberry.png';
import strawberryJson from '../../assets/animations/strawberry.json';
import strawberryAtlas from '../../assets/animations/strawberry.txt';

import lavender from '../../assets/animations/lavender.png';
import lavenderJson from '../../assets/animations/lavender.json';
import lavenderAtlas from '../../assets/animations/lavender.txt';

import tree from '../../assets/animations/tree.png';
import treeJson from '../../assets/animations/tree.json';
import treeAtlas from '../../assets/animations/tree.txt';

// import cathedralOfWaxAndHoney from '../../assets/audio/cathedralOfWaxAndHoney.mp3';
// import ambientMusic from '../../assets/audio/monarchiesAmbient.mp3';

class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'Boot' });
  }

  preload() {

    this.load.atlas('sprites', textureAtlas, textureAtlasJson);
    // this.load.audio('cathedralOfWaxAndHoneyMusic', cathedralOfWaxAndHoney);
    // this.load.audio('ambientMusic', ambientMusic);

    // Load plugins
    utility.addPluginsToScene(this);

  }

  create() {
      this.scene.add('lobbyScene', LobbyScene, true);
  }
}

export default BootScene;



// WEBPACK FOOTER //
// ./src/scenes/Boot/BootScene.js